/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every option has an equal chance of winning.`)
};

const es_dw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada opción tiene la misma probabilidad de ganar.`)
};

const de_dw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Option hat die gleiche Gewinnchance.`)
};

const nl_dw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke optie heeft een gelijke kans om te winnen.`)
};

const fr_dw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque option a une chance égale de gagner.`)
};

const it_dw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni opzione ha la stessa probabilità di vincere.`)
};

const pt_br2_dw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda opção tem a mesma chance de vencer.`)
};

const pt_dw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as opções têm a mesma probabilidade de vencer.`)
};

const ja_dw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの選択肢も当選確率は同じです。`)
};

const zh_dw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个选项获选的概率完全相同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_ex3", locale)
	if (locale === "en") return en_dw_ex3(inputs)
	if (locale === "es") return es_dw_ex3(inputs)
	if (locale === "de") return de_dw_ex3(inputs)
	if (locale === "nl") return nl_dw_ex3(inputs)
	if (locale === "fr") return fr_dw_ex3(inputs)
	if (locale === "it") return it_dw_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_dw_ex3(inputs)
	if (locale === "pt") return pt_dw_ex3(inputs)
	if (locale === "ja") return ja_dw_ex3(inputs)
	return zh_dw_ex3(inputs)
};